// Ids match M5 reseed (20260729190000_firestore_migration_seeds): DELETE + re-INSERT with
// no explicit ids, continuing autoincrement past the 6 rows from seed_enumerations.
export var TransferOrderStatus;
(function (TransferOrderStatus) {
    TransferOrderStatus[TransferOrderStatus["DRAFT"] = 7] = "DRAFT";
    TransferOrderStatus[TransferOrderStatus["ISSUED"] = 8] = "ISSUED";
    TransferOrderStatus[TransferOrderStatus["PICK"] = 9] = "PICK";
    TransferOrderStatus[TransferOrderStatus["SHIPPED"] = 10] = "SHIPPED";
    TransferOrderStatus[TransferOrderStatus["PARTIALLY_RECEIVED"] = 11] = "PARTIALLY_RECEIVED";
    TransferOrderStatus[TransferOrderStatus["RECEIVED"] = 12] = "RECEIVED";
    TransferOrderStatus[TransferOrderStatus["CANCELLED"] = 13] = "CANCELLED";
})(TransferOrderStatus || (TransferOrderStatus = {}));
//# sourceMappingURL=transfer-order-status.js.map